// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"7751":"40b5dd1b0ee0fd00","8868":"9502e1739c639414","9066":"39d093dd3a77cd91"}[chunkId] + ".css";
};